/**
 * [ File :: B_Animate.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/animate/B_Animate.js
 * @목적 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import BaseCanvas from 'canvas/base/dev/scripts/BaseCanvas'
import B_Util from 'canvas/base/dev/util/B_Util';
import B_Define from 'canvas/base/dev/util/B_Define';

const B_Animate = (function(){

	class B_Animate extends BaseCanvas {

		constructor(canvas, tween, proton) {
	        super(canvas);

	        this._tween  = tween;
			this._proton = proton;
		}

		// ===================== SCALE 처리 =====================

		// @DES :: 좌우 반전
		reverseX(obj) { obj._scaleX = obj._scaleX * -1; }

		// @DES :: 상하 반전
		reverseY(obj) { obj._scaleY = obj._scaleY * -1; }

		// @DES :: 배경 생성

		/**
		 * [ Function :: createBG ]
		 *
		 * @DES :: 배경 생성
		 * @IP1 :: res {json}
		 * @IP2 :: cb {func}
		 * @O.P :: null
		 * @S.E :: 없음
		 */
		createBG(res, cb) {
			for(let key in res) {
				if(res[key].type == B_Define.BG_TYPE)  {
					this.getCanvas().WORLD.setBG(res[key].res);
					this.getCanvas().WORLD.getBG()._alpha = 0;
				}
			}
			this._tween.tween(this.getCanvas().WORLD.getBG(), null, {
				arrStep : [
					{
						option : { alpha : 1 },
						time   : this.getCanvas().time/ 3,
						effect : "none"
					}
				]
			}, () => { if(cb) cb(); })
		}

		/**
		 * [ Function :: itemUp ]
		 *
		 * @DES :: 아이템 먹기 (Tween + Proton)
		 * @IP1 :: obj {obj}
		 * @IP2 :: cb {func}
		 * @O.P :: null
		 * @S.E :: 사용게임타입 { GRID, CONTROL }
		 */
		itemUp(obj, cb) {
			this._tween.centerToTop(obj, (tween) => {
				if(cb) cb(tween);
				/// return 후 firework 동작
				this._proton.firework(
					obj._objParent._container,
					obj._pixelX,
					obj._pixelY,
					obj._gridDisX,
					B_Define.FIREWORK_DUMMY_RED)
			});
		}

		/**
		 * [ Function :: actionUp ]
		 *
		 * @DES :: 행동(아이템) 먹기 (Tween + Proton)
		 * @IP1 :: obj {obj}
		 * @IP2 :: cb {func}
		 * @O.P :: null
		 * @S.E :: 사용게임타입 { GRID, CONTROL }
		 */
		actionUp(obj, cb) {
			this._tween.centerToTop(obj, (tween) => {
				if(cb) cb(tween);
				/// return 후 firework 동작
				this._proton.firework(
					obj._objParent._container,
					obj._pixelX,
					obj._pixelY,
					obj._gridDisX,
					B_Define.FIREWORK_DUMMY_BLUE)
			});
		}

	}

	return B_Animate
}());

export default B_Animate;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/animate/B_Animate.js